import request from '@/utils/request'


// 查询平台推送分页
export function pageShare(query) {
  return request({
    url: '/video/share/page',
    method: 'get',
    params: query
  })
}

// 查询平台推送详细
export function getShare(data) {
  return request({
    url: '/video/share/detail',
    method: 'get',
    params: data
  })
}

// 新增平台推送
export function addShare(data) {
  return request({
    url: '/video/share/add',
    method: 'post',
    data: data
  })
}

// 修改平台推送
export function updateShare(data) {
  return request({
    url: '/video/share/edit',
    method: 'post',
    data: data
  })
}

export function changeIsOpen(data) {
  return request({
    url: '/video/share/changeIsOpen',
    method: 'post',
    data: data
  })
}

// 删除平台推送
export function delShare(data) {
  return request({
    url: '/video/share/delete',
    method: 'post',
    data: data
  })
}
